<template>
    <div class="reg">
        <div class="reg-class">
            <div class="reg-class-select" v-clickoutside="closeInputSelect" @click="openInputSelect()">
                <span class="reg-class-select-text">{{searchStatusLabal()}}</span>
                <span class="reg-class-select-icon el-icon-arrow-down" ></span>
            </div>
            <div class="reg-class-option" :class="{'open' : isOpenInputSelect}">
                <div class="reg-class-option-item" v-for="(item, index) in regPreSelectList" :key="index"
                    @click="chooseInputSelectOption(item.value)">{{item.key}}</div>
            </div>
        </div>
        <div class="reg-info">
            <span>連線：</span>
            <i class="reg-status-icon tag-success">正常</i>
            <i class="reg-status-icon tag-warning">故障</i>
            <i class="reg-status-icon tag-none">無</i>
        </div>
        <div class="paca-group">
            <div class="paca-group-list" :class="`list-${index}`" v-for="(item, index) in regList" :key="index" :name="item.id == '' ? 'undefind' : item.id">
                <div class="paca-group-list__header" @click="itemCollapse(index, item)">
                    <i class="paca-group-list__header-icon"></i>
                    <span class="paca-group-list__header-text">
                        <span class="paca-group-list__header-text-title">
                            {{item.id == "" ? "待處理" : item.id}}
                        </span> 
                        <span class="paca-group-list__header-text-length">{{item.count}}</span>
                    </span>
                </div>
                <div class="paca-group-list__content">
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-site-name">{{$t("table.header.siteName")}} ({{item.result.length}})</div>
                            <div class="paca-table__header-item item-column column-ip">{{$t("table.header.ip")}}</div>
                            <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                            <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                            <div class="paca-table__header-item item-column column-hw">{{$t("table.header.hw")}}</div>
                            <div class="paca-table__header-item item-column column-box">{{$t("table.header.box")}}</div>
                            <div class="paca-table__header-item item-column column-sw">{{$t("table.header.sw")}}</div>
                            <div class="paca-table__header-item item-column column-hw">{{$t("table.header.createTime")}}</div>
                            <div class="paca-table__header-item item-column column-connection">{{$t("table.header.connection")}}</div>
                            <div class="paca-table__header-item item-column column-action"></div>
                        </div>
                        <div class="paca-table__body" v-if="item.result.length > 0">
                            <div class="paca-table__body-col" v-for="(secItem, secIndex) in item.result" :key="secIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-site-name overflow-text">
                                        <a :href="secItem.http_href" target="_blank">{{secItem.name}}</a>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-ip">{{secItem.ip}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-site overflow-text">{{secItem.site}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-vendor">{{secItem.vendor}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-hw">{{secItem.hw}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-box overflow-text">{{secItem.box}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-sw">{{secItem.sw}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-created">{{secItem.created}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-connection">
                                        <i class="reg-status-icon" :class="regResultSystemIcon.threeType[secItem.net]">NET</i>
                                    </div> 
                                    <div class="paca-table__body-col-list-item item-column column-action">
                                        <button class="column-action-button el-icon-document" @click="openItemInfoDialog(secItem)"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="paca-table__empty" v-else>{{isLoading ? '讀取中...' : '暫無資料'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="reg-list-viewinfo-dialog" :visible.sync="isViewItemInfoDialog">
            <div slot="title">場站資訊</div>
            <div class="reg-list-viewinfo-dialog__body" v-if="viewItem">
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.siteName")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <a :href="viewItem.http_href" target="_blank">{{viewItem.name}}</a>
                    </div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.ip")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.ip}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.site")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.site}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.vendor")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.vendor}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.hw")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.hw}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.box")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.box}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.sw")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.sw}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.createTime")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">{{viewItem.created}}</div>
                </div>
                <div class="reg-list-viewinfo-dialog__body-item">
                    <div class="reg-list-viewinfo-dialog__body-item-label">{{$t("table.header.connection")}}</div>
                    <div class="reg-list-viewinfo-dialog__body-item-value">
                        <i class="reg-status-icon" :class="regResultSystemIcon.threeType[viewItem.net]">NET</i>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="reg-search-info-dialog__footer-button main-button" @click="CloseItemInfoDialog">確認</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import itemTrim from '@/script/trim/trim.js'
import * as api from '@/script/apiService/api.js'
import * as regListMapping from '@/script/regListMapping/regListMapping.js'
import {getFullTime} from '@/script/time/time.js'

export default {
    name: "reg",
    data(){
        return{
            regList: [],
            regCollapse: "",
            regListStatus: regListMapping.getRegSystemStatusMappingList(),
            regResultSystemIcon: regListMapping.getRegSystemIconMappingList(),
            reRsultDeviceIcon: regListMapping.getRegDeviceIconMappingList(),
            updateTime: '',
            isLoading: false,
            loadingMethod: null,
            tableLoading: false,
            editingItem: null,
            sourceEditingCollectionMark: null,
            isEditingDialogOpen: false,
            infoItem: null,
            isInfoDialogOpen: false,
            isOpenInputSelect: false,
            viewItem: null,
            isViewItemInfoDialog: false,
            searchStatus: 0,
            searchGroup: '0',
            regPreSelectList: [
                {key: "依代碼分類", value: 0},
                {key: "依版本分類", value: 1},
            ],
            isViewCollapse: [],
            hasDataCollapse: [],
        }
    },
    methods: {
        async itemCollapse(index, item){
            if(document.querySelector(`.list-${index}`).classList.contains("is-active")){
                document.querySelector(`.list-${index}`).classList.remove("is-active");
            }else{
                if(item.count != 0 && item.result.length == 0){
                    let sendData = {
                        group_name: this.searchStatus == 0 ? 'vendor_key' : 'sw',
                        group_id: item.id
                    }
                    let res = await api.postPartnerRegGroupInfo(sendData);
                    if(!res.error_status){
                        res[0].result.forEach((item) =>{
                            item.extra_info.pub_http = item.extra_info.pub_http || 15000;
                            item.extra_info.pub_ssh = item.extra_info.pub_ssh || 15001;
                            item.http_href = `http://${item.ip}:${item.extra_info.pub_http}`;
                            item.ssh_href = `ssh://op@${item.extra_info.pub_ip ? item.extra_info.pub_ip : item.ip}:${item.extra_info.pub_ssh}`;
                        })
                        res[0].result.sort(function(a, b){
                            if(a.site.length > 7){
                                return 1;
                            }else if(a.site > b.site){
                                return 1;
                            } else if (a.site < b.site){
                                return -1;
                            } else {
                                return 0;
                            }
                        })
                        item.result = res[0].result;
                        item.count = res[0].result.length;
                    } else if(res.error_status != '401' && res.error_status != '504'){
                        this.$message.error({
                            showClose: true,
                            duration: 2500,
                            message: "發生錯誤!"
                        })
                    }
                    
                }
                document.querySelector(`.list-${index}`).classList.add("is-active");
            }
        },
        closeInputSelect(){
            this.isOpenInputSelect = false;
        },
        openInputSelect(){
            this.isOpenInputSelect = !this.isOpenInputSelect;
        },
        chooseInputSelectOption(value){
            this.searchStatus = value;
            this.getAdminAllRegInfo();
        },
        searchStatusLabal(){
            let status = this.regPreSelectList.find(item => item.value == this.searchStatus);
            return status.key
        },
        async getAdminAllRegInfo(){
            this.regList = [];
            let res = null;
            if(this.searchStatus == '1'){
                res = await api.getPartnerAllRegInfo('sw');
            } else if(this.searchStatus == '0'){
                res = await api.getPartnerAllRegInfo();
            }
            if(!res.error_status){
                if(this.searchStatus == 0){
                    let tempItem = res.shift();
                    res.push(tempItem);
                }
                this.regList = res;
                this.isLoading = false;
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
             
        },
        async reload(){
            this.isLoading = true;
            let res = await this.getAdminAllRegInfo();
            if(!res.error_status){
                this.regList = res;
                this.$message.success({
                    showClose: true,
                    duration: 2500,
                    message: "update success!"
                })
                let nowTime = new Date();
                this.updateTime = getFullTime(nowTime);
                this.isLoading = false;
            }
        },
        async updateRegStatus(id, value){
            let data = {
                id: id,
                status: value
            }
            let res = await api.putRegSetting(data);
            if(!res.error_status){

            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    showClose: true,
                    duration: 2500,
                    message: "發生錯誤!"
                })
            }
        },
        openItemInfoDialog(item){
            this.viewItem = JSON.parse(JSON.stringify(item));
            this.isViewItemInfoDialog = true;
        },
        CloseItemInfoDialog(){
            this.isViewItemInfoDialog = false;
        },
        gotoSearchReg(site){
            this.$router.push({
                name: 'RegList',
                params: {
                    site: site
                }
            })
        }
    },
    async mounted(){
        this.getAdminAllRegInfo();
    },
    async activated(){
        await api.getUserLogin();
    }
}
</script>